import SError from './s-error'

export default SError
